<template>
  <div>
    <el-dialog :title="type == 'add' ? '设置模板' : '变更模板'" :visible.sync="visible" width="510px" class="my-dialog-template" :close-on-click-modal="false">
      <el-form :inline="true" :model="formData" ref="formRef" class="my-form-template" label-width="100px" v-loading="loading">
        <el-form-item label="团队" class="full">
          <span>{{ formData.deptmantName }}</span>
        </el-form-item>
        <el-form-item label="原模板" class="full" v-if="type != 'add'">
          <span>{{ formData.commissonTemplateName }}</span>
        </el-form-item>
        <el-form-item label="新模板" prop="commissonTemplateCode" class="full" :rules="$tools.formRule.required('请选择新模板')">
          <el-select clearable v-model="formData.commissonTemplateCode" placeholder="请选择">
            <el-option v-for="(bean, i) in templateList" :key="i" :label="bean.name" :value="bean.code"></el-option>
          </el-select>
          <div class="form-info-text">更换后，该团队所有产品服务费将变更为新模板内的产品服务费</div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="warning" plain @click="visible = false">取消</el-button>
        <el-button type="warning" :loading="loading" class="bgBtn" @click="save()">保存</el-button>
      </div>
    </el-dialog>
    <modalLoading ref="modalLoading" class="modal-loading"></modalLoading>
  </div>
</template>
<script>
import modalLoading from "@/components/modalLoading";
export default {
  data: () => ({
    visible: false,
    loading: false,
    formData: {
      commissonTemplateCode: ''
    },
    templateList: [],
    type: "add",
  }),
  components: { modalLoading },
  mounted() {
  },
  methods: {
    open(data = {}, type) {
      console.log(data)
      this.type = type;
      this.formData = JSON.parse(JSON.stringify(data))
      // this.formData.commissonTemplateCode = '';
      this.$set(this.formData, 'commissonTemplateCode', '')
      this.visible = true
      this.$refs.formRef && this.$refs.formRef.clearValidate()
      this.getAllTemplate();
    },
    // 查询所有模板
    getAllTemplate() {
      this.$http({
        url: '/master/commissonTemplate/read/all',
        type: 'PUT',
        params: {
          mechanId: this.formData.type == 1 ? this.formData.parentDeptId : this.formData.deptId,
          type: this.formData.type
        },
      }).then((res) => {
        this.templateList = res.data.filter(i => i.id != this.formData.commissonTemplateId)
      })
    },
    save() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            mechanId: this.formData.deptId,
            commissonTemplateCode: this.formData.commissonTemplateCode,
          }
          if (this.formData.type == 2) {
            //员工模板
            params.mechanId = this.formData.userId
          }
          this.$http({
            url: "/master/commissonTemplate/allotTemplate",
            type: 'POST',
            params: params,
          }).then(res => {
            this.$message.success("添加成功");
            this.loading = false;
            const template = this.templateList.find((item) => {
              return item.code == params.commissonTemplateCode;
            });
            this.$emit("reload", template);
            this.visible = false;
          }).catch(() => {
            this.loading = false;
          })
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template /deep/ {
  .form-info-text {
    color: #a8adb7;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 5px;
  }
}
</style>